/**
 * An enumeration object that defines the types of notifications in the system. Each property of the NotifyType object
 * represents a different category of notifications that can be used to indicate various outcomes or statuses in the
 * application.
 *
 * @enum {string}
 * @readonly
 * @property {string} Error - Represents an error notification, denoted by the string 'negative'.
 * @property {string} Info - Represents an informational notification, denoted by the string 'info'.
 * @property {string} Success - Represents a success notification, denoted by the string 'positive'.
 * @property {string} Warning - Represents a warning notification, denoted by the string 'warning'.
 */
export var NotifyType = Object.freeze({
  Error: 'negative',
  Info: 'info',
  Success: 'positive',
  Warning: 'warning'
});